import { render, staticRenderFns } from "./CertificationPreviewModal.vue?vue&type=template&id=163a1b34"
import script from "./CertificationPreviewModal.vue?vue&type=script&lang=js"
export * from "./CertificationPreviewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports